import axios from 'axios'

axios.interceptors.request.use(request => {
    if (window.addiesaas.location && window.addiesaas.location.name) {
        request.headers.common['X-Location'] = window.addiesaas.location.name
    }

    return request
})
